export default "__VITE_ASSET__BEI$twj9__"